import React, { Component } from "react";
import Loader from "../../../../../Common/Component/Loader";
import { DatePicker, message, Select, Modal } from "antd";
import moment from "moment-timezone";
import { map, isEmpty } from "lodash";
import * as yup from "yup";
import _ from 'lodash';
import axios from "../../../../../../Lib/axios";
import { formatToCurrency } from "../../../../../../Tools/formatToCurrency";

const { Option } = Select;

class AddCreditMemo extends Component {
  state = {
    loader: false,
    invoice_date: '',
    due_date: '',
    rows: [{ service_uuid: '', type: '', date: '', description: '',quantity:1, price: '', taxChecked: false, tax: '',total:'',reason:'' }],
    description: '',
    serviceOrderNumberList: {},
    total: '',
    sales_tax: '',
    balance_due: '',
    refund_amount:'',
    quantity:1,
    amount_received: '',
    serviceOrder: {},
    addInvoice: {},
    btn_active: false,
    isApprove: false,
    errors: {},
    description_data: [],
    service_order_uuid: '',
    serviceList: [],
    changedLineItemIndex: -1,
    reason:{},
    creditMemo:{},
    creditMemoLineItem:{},
    creditMemo_uuid : this.props.creditMemo_uuid,
    creditMemoDetail:{},
    indexWorkOrder:null,
    typeList:[{key:'Product',value:'product'},{key:'Service',value:'service'}],
    remaining_balance:'',
    credit_applied:0,
    total_with_tax:'',
    showDelete:false
  }

  componentDidMount = () => {
    this.setState({ loader: true })
    this.props.getServiceOrderNumberList({ user__uuid: this.props.customerId })
    // this.props.getInvoiceDescription("2f4e73bc-cb88-3546-a6c6-475b50211d80");
    if(this.props.creditMemo_uuid){
      this.props.getCreditMemoDetails({uuid:this.props.creditMemo_uuid});
    }

  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { serviceOrderNumberList, serviceOrder, creditMemo,creditMemo_uuid,rows,creditMemoDetail } = this.state;
    // message.destroy()
    if (Object.keys(nextProps?.Invoice?.errors).length > 0
      && JSON.stringify(nextProps?.Invoice?.errors) !== JSON.stringify(this.props?.Invoice?.errors)) {
      // this.setState({loader: false})
      message.error('Something went wrong', 10)
    }
    let rowsArr = []
    if (Object.keys(nextProps?.Invoice?.creditMemoDetail).length > 0 && JSON.stringify(nextProps?.Invoice?.creditMemoDetail) !== JSON.stringify(creditMemoDetail)) {
      this.setState({ loader: true })
      let creditMemoDetail = nextProps?.Invoice?.creditMemoDetail;
      let lineItems = nextProps?.Invoice?.creditMemoDetail.line_items;
      lineItems.map(function(item,index){
        rowsArr.push({reason:item?.reason, service_uuid: item?.service_uuid, type: item?.type, date: item?.date, description:item?.description,quantity:item?.quantity, price: item?.amount, taxChecked: false, tax: item?.tax, sub_description:'',isEditRow:false,creditMemo_uuid:nextProps?.creditMemo_uuid?nextProps?.creditMemo_uuid:null,total: item?.tax+(item?.amount*item?.quantity),service_code:item?.service_code})
        // axios.post(`/invoice-line-item/get-tax-amount/`, {service_uuid: item?.service_uuid, amount: item.amount*item.quantity, item_type: item?.type}).then((response) => {
        //   rowsArr.push({reason:item?.reason, service_uuid: item?.service_uuid, type: item?.type, date: item?.date, description:item?.description,quantity:item?.quantity, price: item?.amount, taxChecked: false, tax: response.data.total_tax, sub_description:'',isEditRow:false,creditMemo_uuid:nextProps?.creditMemo_uuid?nextProps?.creditMemo_uuid:null,total: response.data.total_tax+(item?.amount*item?.quantity)})
        // }).catch(error => {
        //   message.error(`Error occurred while calculating the Tax.`, 30);
        // });
      });
      setTimeout(() => {
        this.setState({description: creditMemoDetail?.description,rows:rowsArr,loader: false,creditMemoDetail:nextProps?.Invoice?.creditMemoDetail,due_date:creditMemoDetail.date_creditmemo,sales_tax:creditMemoDetail.sales_tax,total_with_tax:creditMemoDetail.total_with_tax,total:creditMemoDetail.total,remaining_balance:creditMemoDetail?.remaining_balance,credit_applied:creditMemoDetail.total_with_tax-creditMemoDetail?.remaining_balance})
        this.calculateTotal();
        this.setState({ loader: false })
      }, 500);
    }

   
    //get service order number list
    if (Object.keys(nextProps?.Invoice?.serviceOrderNumberList).length > 0
      && JSON.stringify(nextProps?.Invoice?.serviceOrderNumberList) !== JSON.stringify(serviceOrderNumberList)) {
      this.setState({ serviceOrderNumberList: nextProps?.Invoice?.serviceOrderNumberList });
      let arr = [];
      let arr1 = nextProps?.Invoice?.serviceOrderNumberList?.data.map(function(item, i){
        item.services.map(function(service,s){
          arr.push(service)
        })
      })
      let rowsFilter= this.state.creditMemo_uuid?
        arr.filter(function( rf ) {
          return rf.invoice_status!=='draft' && rf.status==="complete" && (rf.is_auto_invoice_genrated === true || rf.is_manual_invoice_generated===true)  && ((rf.is_credit_memo_generated===false || rf.is_credit_memo_generated===true) && rf.credit_memo_count<2);
        }):
        arr.filter(function( rf ) {
          return rf.invoice_status!=='draft' && rf.status==="complete" && (rf.is_auto_invoice_genrated === true || rf.is_manual_invoice_generated===true)  && rf.is_credit_memo_generated===false;
        });  
      this.setState({
        serviceList:rowsFilter
      })
    }

    // get service order
    if (Object.keys(nextProps?.ServiceOrder?.viewOrder).length > 0
      && JSON.stringify(nextProps?.ServiceOrder?.viewOrder) !== JSON.stringify(serviceOrder)) {
      this.setState({ serviceOrder: nextProps?.ServiceOrder?.viewOrder });
    }

    //Get Invoice Description
    if (Object.keys(nextProps?.InvoiceDescription?.data).length > 0
      && nextProps?.InvoiceDescription?.data !== this.props.InvoiceDescription.data) {
      this.setState({
        // loader: false,
        description_data: nextProps?.InvoiceDescription?.data
      })
    }

    //Get Invoice Description
    if (Object.keys(nextProps?.Invoice?.creditMemo).length > 0) {
      this.setState({
        loader: false,
      })
      nextProps.onChangeView(0)
      message.success(`${nextProps?.Invoice?.creditMemo?.message}`, 30);
    }

    //Get Work Order Type Description
    if (Object.keys(nextProps?.WorkOrderTypeDescription?.data).length > 0 && nextProps?.WorkOrderTypeDescription?.data !== this.props.WorkOrderTypeDescription.data) {
      rows[this.state.indexWorkOrder].description_arr = nextProps?.WorkOrderTypeDescription?.data
      this.setState({
        // loader: false,
        rows
      })
    }

    // get sales tax
    if (Object.keys(nextProps?.Invoice?.getSalesTax).length > 0
      && JSON.stringify(nextProps?.Invoice?.getSalesTax) !== JSON.stringify(this.props?.Invoice?.getSalesTax)) {
      const {rows, changedLineItemIndex} = this.state;
      rows[changedLineItemIndex].tax = nextProps?.Invoice?.getSalesTax?.total_tax
      this.setState({rows}, () => this.calculateTotal())
    }
    if(!this.props.creditMemo_uuid){
      this.setState({ loader: false })
    }
  }

  // convert date time from utc to local time
  UTCToLocal = (date) => {
    let stillUtc = moment.utc(date).toDate();
    return moment(stillUtc).local();
  }

  // convert date time from local to utc
  localToUTC = (date) => {
    return moment.utc(date)
  }

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d{0,2})?$/;
    return (reg.test(value))
  };

  // on invoice detail change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value })
  }

  // on item row change
  onRowDataChange = (e, index, type) => {
    const { rows,serviceList } = this.state;
    const value = type === 'bool' ? e.target.checked : e.target.name==="price"?e.target.value.replace('-', '').trim():e.target.value;
    Object.assign(rows[index], { [e.target.name]: value })
    this.setState({ rows, changedLineItemIndex: index }, () => {
      const {rows} = this.state;
      if (rows[index].service_uuid && rows[index].price && rows[index].type) {
        this.props.getSalesTax({service_uuid: rows[index].service_uuid, amount: rows[index].price*(rows[index].quantity?rows[index].quantity:1), item_type: rows[index].type})
      } else if (isEmpty(rows[index].price)) {
        rows[index].tax = 0
      }
      this.setState({rows}, () => this.calculateTotal())
    })
    
    if(e.target.name==="service_uuid"){
      const value = type === 'bool' ? e.target.checked : e.target.value;
      Object.assign(rows[index], { [e.target.name]: value })
      let filterWorkOrder = rows.filter((item)=>{
        return item.service_uuid===e.target.value
      })
      let typeFilter = _.map(filterWorkOrder,'type');
      typeFilter = typeFilter.filter((item)=>{
        return item!==""
      })
      var res = _.map(this.state.typeList,'value').filter( function(n) { return !this.has(n) }, new Set(typeFilter) );
      let typoListFilter = []
      res.map((item)=>{
        if(item==='product'){
          typoListFilter.push({key:'Product',value:'product'})
        }
        if(item==='service'){
          typoListFilter.push({key:'Service',value:'service'})
        }
      })

      this.setState({indexWorkOrder:index},() =>this.props.getWorkOrderTypeDescription(e.target.value))
      this.setState({ rows, changedLineItemIndex: index }, () => {
        const {rows} = this.state;
        if (rows[index].service_uuid && rows[index].price && rows[index].type) {
          this.props.getSalesTax({service_uuid: rows[index].service_uuid, amount: rows[index].price*(rows[index].quantity?rows[index].quantity:1), item_type: rows[index].type})
        } else if (isEmpty(rows[index].price)) {
          rows[index].tax = 0
        }
        rows[index].typeList = typoListFilter;
        this.setState({rows}, () => this.calculateTotal())
      })
    }
  }

  // calculate total
  calculateTotal = () => {
    let { rows, amount_received } = this.state;
    let new_total = 0, salesTax = 0, balance_due = 0, quantity = 1, refund_amount = 0, totalWithTax = 0;
    map(rows, x => {
      salesTax = parseFloat(salesTax) + parseFloat(x?.tax)
      new_total = parseFloat(new_total) + (parseFloat(x.price || 0)*parseInt(x.quantity || 1))
      balance_due = parseFloat(balance_due) + ((parseFloat(x.price || 0)*parseInt(x.quantity || 1)) + parseFloat(x.tax || 0))
      quantity = parseInt(x.quantity || 1)
      refund_amount = parseFloat(refund_amount) + parseFloat(x.refund_amount?x.refund_amount:0)
      totalWithTax = salesTax+new_total
    })
    this.setState({ total_with_tax:totalWithTax,total: new_total, sales_tax: salesTax, quantity:quantity, balance_due: parseFloat(balance_due - amount_received).toFixed(2),refund_amount:refund_amount.toFixed(2) })
  }

  // on delete row
  onDeleteRow = (index) => {
    const { rows } = this.state;
    // if (index === 0) {
    //   map(rows, x => Object.assign(x, { service_order_uuid: rows?.[0]?.service_order_uuid || '' }))
    // }
    rows.splice(index, 1);
    this.setState({ rows }, () => { this.calculateTotal(); })
  }

  // on add item
  onAddItem = () => {
    const { rows } = this.state;
    rows.push({ service_uuid: '', type: '', date: '', description: '',quantity:1, price: '', taxChecked: false, tax: '',isEditRow:true })
    this.setState({ rows })
  }

  // on add item
  onClearAll = () => {
    if(this.props.creditMemo_uuid){
      let rowsFilter= this.state.rows.filter(function( rf ) { 
        return rf.isEditRow === false;
      });
      this.setState({rows:rowsFilter},() => { this.calculateTotal(); })
    }else{
      this.setState({ rows: [{ service_uuid: '', type: '', date: '', description: '',quantity:1, price: '', taxChecked: false, tax: '' }] }, () => { this.calculateTotal(); })
    }
  }

  // on service order change
  onServiceOrderChange = (e) => {
    const {serviceOrderNumberList, rows} = this.state;
    this.props.getServiceOrderById(e)
    this.props.getInvoiceDescription(e)
    this.setState({ 'service_order_uuid': e })
    const serviceList = serviceOrderNumberList?.data?.find(x => x.uuid === e)

    map(rows, x => {
      // x.isEditRow = true
      const service_num = serviceList?.services?.find(y => y.uuid === x.service_uuid)
      if (isEmpty(service_num)) {
        x.service_uuid = ''
        x.service_code = ''
      }
    })

    this.setState({ 'serviceList': serviceList?.services, rows })
  }

  // validate required fields
  validate = () => {
    const { rows, invoice_date, due_date, service_order_uuid } = this.state;
   
    const schema = yup.object().shape({
      // service_order_uuid: yup.string().required('Service order# is required'),
      rows: yup.array(yup.object({
        service_uuid: yup.string().required('Work Order#  is required'),
        type: yup.string().required('Type is required'),
        reason: yup.string().required('Reason is required'),
        // date: yup.string().required('Date is required'),
        description: yup.string().required('Description is required'),
        quantity: yup.string().required('Quantity is required'),
        other_description: yup.string().when('description', {
          is: 'other',
          then: yup.string().required('Other Description is required'),
        }),
        price: yup.string().test('match', 'Price should have a valid format', (price) => {
          return !isNaN(parseFloat(price))
        }),
        // price: yup.string().test('match', 'Price should have a valid format and should be less then $-30', (price) => {
        //   return parseFloat(price)<31 && parseFloat(price)>0 
        // })
      })),
      // invoice_date: yup.string().required('Invoice Date is required'),
      due_date: yup.string().required('Credit Memo Date is required'),
      // due_date: yup.string().required('Credit Memo Date is required').test("compare", "Invalid credit memo date", (due_date) => moment(this.state.invoice_date).isBefore(moment(due_date))),
    });

    const data = { service_order_uuid, rows, invoice_date, due_date };

    setTimeout(() => {
      schema.validate(data, { abortEarly: false }).then(() => {
        if(!rows.length){
          message.error('Atleast one line item is required.');
          this.setState({btn_active: false, errors: {}});
        }else{
          this.setState({ btn_active: true, errors: {} })
          this.onSave();
        }
        
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => { err_data[item.path] = item.message })
        this.setState({ errors: err_data, is_btn_active: false })
      });
    }, 500)
  };

    //on edit row
    onEditRow = (id_edit_invoice, index,uuid) => {
      const { rows } = this.state;
      Object.assign(rows[index], { 'isEditRow': id_edit_invoice })
      this.setState({ rows,indexWorkOrder:index }, ()=>this.props.getWorkOrderTypeDescription(uuid))
    }

  // on save
  onSave = () => {
    const { invoice_date, due_date, description, serviceOrder, quantity ,balance_due, amount_received, service_order_uuid,reason,rows} = this.state;
    const { addCreditMemo, customerId } = this.props;
    const address = !isEmpty(serviceOrder?.billing_address) ? serviceOrder?.billing_address : !isEmpty(serviceOrder?.service_address) ? serviceOrder?.service_address : {};

    if (!address?.geo_location) {
      delete address?.geo_location
    }
    var arr = [];

    var getKeys = _.uniqBy(rows, 'service_uuid');
    // map(getKeys,(k,i)=>{
    let objarr = {
      user:this.props.customerId,
      processed_by_uuid:this.props.customerId,
      // service:k.service_uuid,
      date_creditmemo:due_date ? this.localToUTC(due_date).format('YYYY-MM-DD') : null,
    };
    let lineItems = [];
    let total = 0;
    let salesTax = 0;
    let totalWithTax = 0;
    let creditmemouuid=null;
    map(rows,(r,i)=>{
      // if(r.service_uuid===k.service_uuid){
      let obj = {
        date:due_date ? this.localToUTC(due_date).format('YYYY-MM-DD') : null,
        uuid:r.service_uuid,
        service_uuid:r.service_uuid,
        service:r.service_uuid,
        tax:r.tax,
        reason:r.reason,
        type:r.type,
        description:r.description,
        amount:r.price,
        quantity:r.quantity,
        creditMemo_uuid:r.creditMemo_uuid?r.creditMemo_uuid:null
      }
      if(r.creditMemo_uuid){
        creditmemouuid = r.creditMemo_uuid
      }
      total = parseFloat(total)+(parseFloat(r.price)*parseFloat(r.quantity));
      salesTax = parseFloat(salesTax)+parseFloat(r.tax);
      totalWithTax = parseFloat(totalWithTax)+parseFloat(r.tax)+(parseFloat(r.price)*parseFloat(r.quantity))
      lineItems.push(obj); // }
    })
    objarr.creditmemouuid = creditmemouuid;
    objarr.line_items=lineItems;
    objarr.total=total;
    objarr.sales_tax=salesTax.toFixed(2);
    objarr.total_with_tax=totalWithTax;
    objarr.description = description;
    // arr.push(objarr);
    // })
    console.log("objarr",objarr);
    this.setState({loader:true})
    addCreditMemo(objarr)
    this.setState({ description_data: [] })
  }

  pos_to_neg =(num) =>{return !isNaN(num)?-Math.abs(num):0}

  // render Item Row
  renderItemRow = (item, index) => {
    const { serviceList, errors, description_data, typeList } = this.state;
    let total = parseFloat(item.price*item.quantity)+ parseFloat(item.tax);
    let workOrder = serviceList?serviceList.find(element => element.uuid === item.service_uuid):null;
    var grouped = _.mapValues(_.groupBy(this.state.rows, 'service_uuid'),
      clist => clist.map(car => _.omit(car, 'service_uuid')));
    var newArr = [];
    Object.keys(grouped).map(function(key, index) {
      if(key!=="" && grouped[key].length>=2){
        newArr.push(key)
      }
    });
    let filterServiceList = serviceList?serviceList.filter(x => !newArr.includes(x.uuid)):[];
    return (
      <div className="divrow editrow" key={`items${index}`} style={{marginLeft: "0px"}}>
        {item.isEditRow===false?<div className="dcell stype">{item?.reason ? item?.reason : undefined}</div>:<div className="dcell stype">
          <Select
            dropdownClassName="sm-filter"
            showArrow
            name={'reason'}
            virtual={false}
            style={{ width: '100%' }}
            value={item?.reason ? item?.reason : undefined}
            placeholder={'Reason'}
            onChange={(e) => { this.onRowDataChange({ target: { name: 'reason', value: e } }, index) }}
          >
            <Option value="Service Not Rendered">Service Not Rendered</Option>
            <Option value="Overpayment-Apply to Future Invoice">Overpayment-Apply to Future Invoice</Option>
            <Option value="Inclement Weather">Inclement Weather</Option>
            <Option value="Courtesy Credit">Courtesy Credit</Option>
          </Select>
          {errors?.[`rows[${index}].reason`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].reason`]}</label> : ''}
        </div>}
        {item.isEditRow===false?<div className="dcell sno">{workOrder?.service_code?workOrder?.service_code:item?.service_code}</div>:<div className="dcell sno">
          <Select
            dropdownClassName="sm-filter"
            showArrow
            name={'service_uuid'}
            virtual={false}
            style={{ width: '100%' }}
            value={workOrder?.service_code?workOrder?.service_code:item?.service_code}
            placeholder={'Select'}
            onChange={(e) => {
              this.onRowDataChange({ target: { name: 'service_uuid', value: e } }, index)
            }}
          >
            {map(filterServiceList, (obj) => <Option value={obj?.uuid} key={obj?.uuid}>{obj?.service_code}</Option>)}
          </Select>
          {errors?.[`rows[${index}].service_uuid`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].service_uuid`]}</label> : ''}
        </div>}
        {item.isEditRow===false?<div className="dcell stype">{item?.type ? item?.type : undefined}</div>:<div className="dcell stype">
          <Select
            dropdownClassName="sm-filter"
            showArrow
            name={'type'}
            virtual={false}
            style={{ width: '100%' }}
            value={item?.type ? item?.type : undefined}
            placeholder={'Product/Service'}
            onChange={(e) => { this.onRowDataChange({ target: { name: 'type', value: e } }, index) }}
          >
            {map(item.typeList, (obj) => <Option value={obj?.value} key={obj?.key}>{obj?.key}</Option>)}
          </Select>
          {errors?.[`rows[${index}].type`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].type`]}</label> : ''}
        </div>}
        {item.isEditRow===false?<div className="dcell sdesc">{item.description ? item.description : "Please Select"}</div>:<div className="dcell sdesc">
          <Select
            value={item.description ? item.description : "Please Select"}
            placeholder="Please Select"
            onChange={(e) => { this.onRowDataChange({ target: { name: 'description', value: e } }, index) }}
          >
            {item?.description_arr?.data?.filter(data => data?.type === item?.type).map((item) => {
              return (
                <Option key={item.item}>{item.item}</Option>
              )
            })}
            <Option key="other">Other</Option>
          </Select>
          {errors?.[`rows[${index}].description`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].description`]}</label> : ''}
          {item.description === "other" ?
            <>
              <textarea
                className="sdesc mt-20"
                value={item.other_description}
                onChange={(e) => { this.onRowDataChange({ target: { name: 'other_description', value: e.target.value } }, index) }}
              ></textarea>
              {errors?.[`rows[${index}].other_description`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].other_description`]}</label> : ''}
            </>
            : null
          }
        </div>}
        {item?.type==="product"?item.isEditRow===false?<div className="dcell sprice">{item?.quantity}</div>:<div className="dcell sprice">
          <div className="sprice">
            <input
              readOnly={item?.type==="service"?true:false}
              type="text"
              className="form-control"
              value={item?.quantity}
              name="quantity"
              onChange={(e) => this.onNumericInputChange(e.target.value) && this.onRowDataChange({ target: { name: 'quantity', value: e.target.value } }, index)}
              placeholder="Quantity" />
            {errors?.[`rows[${index}].quantity`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].quantity`]}</label> : ''}
          </div>
        </div>:item.isEditRow===false?<div className="dcell sprice">1</div>:<div className="dcell sprice">
          <div className="sprice">
            <input
              readOnly={true}
              type="text"
              className="form-control"
              value={1}
              name="quantity"
              onChange={(e) => this.onNumericInputChange(e.target.value) && this.onRowDataChange({ target: { name: 'quantity', value: e.target.value } }, index)}
              placeholder="Quantity" />
            {errors?.[`rows[${index}].quantity`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].quantity`]}</label> : ''}
          </div>
        </div>}
        {item.isEditRow===false?<div className="dcell sprice">$-{item?.price}</div>:<div className="dcell sprice">
          <div className="sprice">
            <input
              type="text"
              className="form-control"
              value={item?.price>0?"-"+item?.price:item?.price}
              name="price"
              onChange={(e) => this.onNumericInputChange(e.target.value) && this.onRowDataChange(e, index)}
              placeholder="Price" />
            {errors?.[`rows[${index}].price`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].price`]}</label> : ''}
          </div>
        </div>}
        {item.isEditRow===false?<div className="dcell stax">$-{formatToCurrency(item?.tax)}</div>:<div className="dcell stax">
          <div className="flex ai-center">
            <div className="inline-check-list sm-checks">
              <div className="flex ai-center">
                <div className="sprice"> 
                  ${parseFloat(item?.tax) > 0 ? "-" + formatToCurrency(item?.tax) : '0.00'}
                </div>
              </div>
            </div>
          </div>
        </div> }
        <div className="dcell stax">
          <div className="flex ai-center">
            <div className="inline-check-list sm-checks">
              <div className="flex ai-center">
                <div className="sprice"> 
                  ${parseFloat(total) > 0 ? "-" + formatToCurrency(total): '0.00'}
                </div>
              </div>
            </div>
          </div>
          {item.isEditRow===false && this.state.credit_applied===0?<i className="las la-edit" onClick={() => this.onEditRow(true, index,item?.service_uuid)}></i>:null}
          {this.state.credit_applied!==0 || item?.creditMemo_uuid?null:<i className="las la-trash-alt" onClick={() => this.onDeleteRow(index)} />}
        </div>
      </div>
    )
  }

  // render table
  renderItemTable = () => {
    const { rows, description, total, sales_tax, amount_received, balance_due,refund_amount,remaining_balance,credit_applied,total_with_tax } = this.state;
    const is_payment_recieved = Number(amount_received || "0") > 0
    return (
      <React.Fragment>
        <div className="table-block">
          <div className="div-table">
            <div className="divhead">
              <div className="dcell sdate">Reason</div>
              <div className="dcell sno">Work Order #</div>
              <div className="dcell stype">Type</div>
              <div className="dcell sdesc">Description</div>
              <div className="dcell squantity">Quantity</div>
              <div className="dcell sprice">Amount</div>
              <div className="dcell stax">Tax</div>
              <div className="dcell stax">Total</div>
            </div>
            <div className="divbody">
              {map(rows, this.renderItemRow)}
              <div className="divrow dfoot">
                <div className="dcell">
                  <div className="btn-group">
                    <button className={`btn btn-warning ${this.state.credit_applied!==0 ? "disbale_btn" : ""}`} disabled={this.state.credit_applied!==0} onClick={() => this.onAddItem()}><i className="las la-plus-circle"></i> Add Item</button>
                    <a className={`clear-item btn-warning ${this.state.credit_applied!==0 ? "disbale_btn" : ""}`} disabled={this.state.credit_applied!==0} onClick={() => this.onClearAll()}>Clear All Items</a>
                  </div>
                  <div className="form-group">
                    <div className="fitem">
                      <textarea
                        disabled={this.state.credit_applied!==0}
                        rows="2"
                        className="form-control"
                        name="description"
                        placeholder={"Add a message to the credit memo."}
                        value={description}
                        onChange={(e) => this.onTextChange(e)} />
                    </div>
                  </div>
                </div>
                <div className="dcell flex ai-start flex-end">
                  <div className="price-block">
                    <span>Total</span>
                    <span>Sales Tax</span>
                    <span>Credit Total </span>
                    {this.state.creditMemo_uuid?<span>Credit Applied </span>:null}
                    {this.state.creditMemo_uuid?<span>Remaining Credit Balance</span>:null}
                    {/* <span>Amount Refunded</span> */}
                  </div>
                  <div className="pricing">
                  
                    <span>${parseFloat(total) > 0 ? "-" + formatToCurrency(total) : '0.00'}</span>
                    <span>${parseFloat(sales_tax) >0 ? "-" + formatToCurrency(sales_tax) : '0.00'}</span>
                    <span>${parseFloat(total_with_tax) >0 ? "-" + formatToCurrency(total_with_tax) : '0.00'}</span>
                    {this.state.creditMemo_uuid?<span>${credit_applied ? formatToCurrency(credit_applied) : '0.00'}</span>:null}
                    {this.state.creditMemo_uuid?<span>${remaining_balance ? formatToCurrency(remaining_balance) : '0.00'}</span>:null}
                    {/* <span>${this.props.Invoice ? this.props.Invoice.invoiceDetail.refund_amount?parseFloat(this.props.Invoice.invoiceDetail.refund_amount).toFixed(2) : '0.00':'0.00'}</span> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }

  render() {
    const { loader, invoice_date, due_date, serviceOrder, errors, serviceOrderNumberList, service_order_uuid } = this.state;
    const { onChangeView, customer } = this.props;
    const is_service_order = !isEmpty(serviceOrder?.billing_address) || !isEmpty(serviceOrder?.service_address)
    const address = !isEmpty(serviceOrder?.billing_address) ? serviceOrder?.billing_address : !isEmpty(serviceOrder?.service_address) ? serviceOrder?.service_address : {};
    let rowsFilter= this.state.rows.filter(function( rf ) { 
      return rf.isEditRow === true;
    });
    return (
      <React.Fragment>
        {loader && <Loader />}
        <div className="filter_wrapper">
          <ul className="breadcrumb">
            <li className={"cursor_pointer"}><span onClick={() => { onChangeView(0) }}>Back to all invoices</span></li>
          </ul>
        </div>
        <div className="invoice-container">
          <div className="flex flex-service">
            <div className="flex-1">
              <div className="bill-add">
                <b>Credit to:</b>
                <p>{customer?.first_name} {customer?.last_name}, <br />{is_service_order ? `${address?.address},` : ''} <br />{is_service_order ? `${address?.city}, ${address?.state}, ${address?.zip_code}` : ''}</p>
              </div>
            </div>
            <div className="flex-1">
              <div className="form-group">
                <div className="half-fitem fitem">
                  <div className="half-fitem fitem">
                    {/* <label><b>Service Order#</b></label>
                    <Select
                      dropdownClassName="sm-filter"
                      showArrow
                      name={'service_order'}
                      virtual={false}
                      style={{ width: '100%' }}
                      value={service_order_uuid ? service_order_uuid : undefined}
                      placeholder={'Service Order#'}
                      onChange={(e) => this.onServiceOrderChange(e)}
                    >
                      {map(serviceOrderNumberList?.data, (obj) => <Option value={obj?.uuid} key={obj?.uuid}>{obj?.service_order_number}</Option>)}
                    </Select>
                    {errors?.['service_order_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['service_order_uuid']}</label> : ''} */}
                  </div>
                  {/* <div className="half-fitem fitem">
                    <label><b>Invoice Date</b></label>
                    <DatePicker
                      inputReadOnly
                      style={{ 'width': '100%' }}
                      // disabledDate={(current) => { return current && current <= moment().endOf('day'); }}
                      name='date'
                      format="MM/DD/YYYY"
                      allowClear={false}
                      value={invoice_date ? this.UTCToLocal(invoice_date) : null}
                      onChange={(e) => this.onTextChange({ target: { name: 'invoice_date', value: e } })}
                    />
                    {errors?.['invoice_date'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['invoice_date']}</label> : ''}
                  </div> */}
                  <div className="half-fitem fitem">
                    <label><b>Credit Memo Date</b></label>
                    <DatePicker
                      inputReadOnly
                      style={{ 'width': '100%' }}
                      disabled={this.state.credit_applied===0?false:true}
                      name='date'
                      format="MM/DD/YYYY"
                      allowClear={false}
                      value={due_date ? this.UTCToLocal(due_date) : null}
                      onChange={(e) => this.onTextChange({ target: { name: 'due_date', value: e } })}
                    />
                    {errors?.['due_date'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['due_date']}</label> : ''}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.renderItemTable()}
          <div className="sticky-btn-grp">
            <div className="flex ai-center">
              {/*
                  <div className="flex-1 text-left links">
                    <span>Delete</span>
                    <span>Void</span>
                  </div>
*/}
              <div className="flex-1">
                <button className={`btn btn-warning`} onClick={() => this.validate()}>Save</button>
                <button className={`btn btn-warning`} onClick={() => this.setState({ isApprove: true }, () => this.validate())}>Approve & Send Credit Memo</button>
                <button className={`btn btn-warning`} onClick={() => this.state.creditMemo_uuid && rowsFilter.length===0?this.props.onChangeView(0) :this.setState({showDelete:!this.state.showDelete})}>Cancel</button>
              </div>
            </div>
          </div>
        </div>

        <Modal
          title="Discard the Credit Memo"
          visible={this.state.showDelete}
          onCancel={() => this.setState({showDelete:!this.state.showDelete})}
          className="delete_user_modal"
          width={400}
          footer={[
            <button key="cancel" className="btn btn-brand btn-bdr" onClick={() => this.setState({showDelete:!this.state.showDelete})}>No</button>,
            <button key="upload" className={`btn btn-waning`} onClick={() =>this.props.onChangeView(0)
            }>Yes</button>,
          ]}
        >
          <div>
            <p>{'Do you wish to discard this credit memo?'}</p>
          </div>
        </Modal>

      </React.Fragment>
    );
  }
}

export default AddCreditMemo;
